import { Check, X } from "lucide-react";
import { useLang } from "../i18n";
import { Reveal, Section, SectionHead } from "./Reveal";

export const Manifesto = () => {
  const { t } = useLang();

  return (
    <Section>
      <SectionHead label={t.start.label} title={t.start.heading} sub={t.start.sub} />
      <div className="grid gap-6 md:grid-cols-2">
        <Reveal>
          <div
            data-testid="manifesto-legacy"
            className="h-full rounded-2xl border border-line bg-ink-900/50 p-8 md:p-10"
          >
            <p className="font-mono text-xs uppercase tracking-[0.25em] text-mist">
              {t.start.legacyTitle}
            </p>
            <ul className="mt-8 space-y-5">
              {t.start.legacy.map((item) => (
                <li key={item} className="flex gap-4 text-mist">
                  <X size={18} className="mt-0.5 shrink-0 text-white/30" />
                  {item}
                </li>
              ))}
            </ul>
          </div>
        </Reveal>
        <Reveal delay={0.1}>
          <div
            data-testid="manifesto-native"
            className="relative h-full overflow-hidden rounded-2xl border border-volt/30 bg-ink-900/50 p-8 md:p-10"
          >
            <div className="pointer-events-none absolute -right-20 -top-20 h-56 w-56 rounded-full bg-volt/15 blur-3xl" />
            <p className="font-mono text-xs uppercase tracking-[0.25em] text-volt">
              {t.start.nativeTitle}
            </p>
            <ul className="mt-8 space-y-5">
              {t.start.native.map((item) => (
                <li key={item} className="flex gap-4 text-white/90">
                  <Check size={18} className="mt-0.5 shrink-0 text-volt" />
                  {item}
                </li>
              ))}
            </ul>
          </div>
        </Reveal>
      </div>
    </Section>
  );
};
